import { FC } from "react";
import S from "../input/index.module.scss";
import { IMaskInput } from "react-imask";

interface IPhoneInput {
  value?: string;
  error?: string;
  setValue: (value: string) => void;
  label: string;
}

const PhoneInput: FC<IPhoneInput> = ({ setValue, value, error, label }) => {
  return (
    <div className={S.container}>
      <div className={S.inputWrapper}>
        <label className={S.label}>{label}</label>
        <IMaskInput mask={"+{7} (000) 000-00-00"} onAccept={val => setValue(val)} value={value} className={S.input} />
      </div>
      {error && <span className={S.error}>{error}</span>}
    </div>
  );
};

export default PhoneInput;
